import React, { useEffect, useState } from "react"
import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { toast } from "react-toastify";
import DeleteIcon from "@mui/icons-material/Delete";
import { InsertDriveFileOutlined, PictureAsPdfOutlined, Upload } from '@mui/icons-material';
import store, { RootState } from "../../../global/config/store.ts";
import { setLoadingFalse, setLoadingTrue } from "../../../global/config/Action/loadingActions.ts";
import { CustomUploadProfilePic } from "../../../apiService/Core/CustomUploadProfilePic.tsx"
import { useSelector } from "react-redux";
import { ApiGetClientEntityByClientGroupId, ApiGetDocuments, ApiGetDocumentType, ApiCreateHelpingDocument, ApiUpdateHelpingDocument, ApiDeleteHelpingDocument } from "../../../apiService/Core/Apicall.tsx";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import mmlogo from '../../../assets/images/MM_logo.png'
import aldilogo from '../../../assets/images/Aldi_logo.png'
import bloomslogo from '../../../assets/images/Blooms_logo.png'
import edit from "../../../assets/images/editIcon.png";

const HelpDocument: React.FC = () => {

    const Clientlist = useSelector((state: RootState) => state.client.clientList);
    const [dialogClient, setDialogClient] = useState<any>(null);
    const [dialogEntityId, setDialogEntityId] = useState<any>(null);
    const [dialogEntityList, setDialogEntityList] = useState<any>([]);
    const [documentType, setDocumentType] = useState<any[]>([]);
    const [helpingDocumentTypeId, setHelpingDocumentTypeId] = useState<any>(null);
    const [dialogDocumentTypeId, setDialogDocumentTypeId] = useState<any>(null);
    const [documentData, setDocumentData] = useState<any[]>([]);
    const [editingDocument, setEditingDocument] = useState<any>(null);
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        seqNo: "",
        fileName: "",
    });
    const [uploadedFiles, setUploadedFiles] = useState<string[]>([]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleClose = () => {
        setOpen(false);
        setEditingDocument(null);
        setFormData({ seqNo: "", fileName: "" });
        setUploadedFiles([]);
        setDialogClient(null);
        setDialogEntityId(null);
        setDialogEntityList([]);
        setDialogDocumentTypeId(null);
    };


    const uploadDocumentImage = async (file: File) => {
        store.dispatch(setLoadingTrue())
        const formData = new FormData()
        const userId: any = localStorage.getItem('userId')
        formData.append("file", file)
        formData.append("fileType", "project_static_files")
        formData.append("userId", userId)

        try {
            const response = await CustomUploadProfilePic(formData)
            store.dispatch(setLoadingFalse())
            toast.success(response.message)
            // Add the uploaded file URL to the state
            setUploadedFiles(prev => [...prev, response.location]);
        } catch (error) {
            console.error("Error uploading file:", error)
            toast.error(error)
        }
    }

    const handleDocumentUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null
        if (file) {
            store.dispatch(setLoadingTrue())
            try {
                await uploadDocumentImage(file)
            } catch (error) {
                console.error("Image upload failed:", error)
            }
        }
    }

    const handleRemoveFile = (index: number) => {
        setUploadedFiles(prev => {
            const updatedFiles = [...prev];
            updatedFiles.splice(index, 1);
            return updatedFiles;
        });
    };

    const handleGetDialogClientEntities = async (clientGroupName: string) => {
        try {
            const data = `?ClientGroupName=${clientGroupName}`;
            const res: any = await ApiGetClientEntityByClientGroupId(data);
            setDialogEntityList(res.data);
        } catch (error) {
            console.error("Error fetching dialog client entities:", error);
        }
    };

    const handleGetdocumentType = async () => {
        try {
            const res = await ApiGetDocumentType();
            const response = res?.data.map((item) => ({
                label: item.type,
                value: item.helpingDocumentTypeId
            }))
            setDocumentType(response)

            if (response.length > 0) {
                setHelpingDocumentTypeId(response[0].value)
            }
        } catch (error) {
            console.error("Error Generating Document Type.", error)
            toast.error("Error Generating Document Type.")
        }
    }

    useEffect(() => {
        handleGetdocumentType()
    }, [])

    const handleGetDocument = async () => {
        try {
            const data = helpingDocumentTypeId !== null ? `?helpingDocumentTypeId=${helpingDocumentTypeId}` : ''
            const res = await ApiGetDocuments(data)
            setDocumentData(res.data)
        } catch (error) {
            console.error("Error Generating Helping Document.", error);
            toast.error("Error Generating Helping Document.");
        }
    }
    useEffect(() => {
        handleGetDocument()
    }, [helpingDocumentTypeId])

    const handleCopyLink = async (url: string) => {
        if (!navigator.clipboard) {
            try {
                const textArea = document.createElement("textarea");
                textArea.value = url;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
                toast.success("Link copied to clipboard!");
            } catch (err) {
                console.error("Fallback: Oops, unable to copy", err);
                toast.error("Failed to copy link.");
            }
            return;
        }

        try {
            await navigator.clipboard.writeText(url);
            toast.success("Link copied to clipboard!");
        } catch (err) {
            console.error("Failed to copy: ", err);
            toast.error("Failed to copy link.");
        }
    };

    useEffect(() => {
        handleGetDialogClientEntities(dialogClient?.clientGroupName)
    }, [dialogClient])

    const handleSubmit = async () => {
        if (!formData.seqNo || !formData.fileName || uploadedFiles.length === 0 || !dialogDocumentTypeId) {
            toast.error("Please fill all required fields.");
            return;
        }

        const payload: any = {
            orderNo: Number(formData.seqNo),
            name: formData.fileName,
            documentUrls: uploadedFiles.join(","),
            helpingDocumentTypeId: dialogDocumentTypeId,
        };

        if (dialogClient?.clientGroupName) {
            payload.clientGroupName = dialogClient.clientGroupName;
        }
        if (dialogEntityId) {
            payload.clientEntityId = dialogEntityId;
        }
        const updatePayload = {
            helpingDocumentId: editingDocument?.helpingDocumentId,
            ...payload
        }

        try {
            store.dispatch(setLoadingTrue());

            if (editingDocument) {
                try {
                    const res: any = await ApiUpdateHelpingDocument(updatePayload);
                    toast.success("Document updated successfully!");
                    handleGetDocument();
                } catch (error) {
                    console.error("Error Updating Documents.", error);
                    toast.error("Error Updating Document.");
                    handleClose();
                }
            } else {
                try {
                    const res: any = await ApiCreateHelpingDocument(payload);
                    toast.success("Helping Document Created Successfully.");
                    handleGetDocument()
                } catch (error) {
                    console.error("Error Crerating Helping Document.", error);
                    toast.error("Error Creating Helping Document.")
                    handleClose()
                }
            }
            handleClose();
        } catch (error: any) {
            console.error("Error saving document:", error);
            toast.error(error?.message || "Failed to save document.");
        } finally {
            store.dispatch(setLoadingFalse());
        }
    };

    const handleDelete = async (id: number) => {
        try {
            const response = await ApiDeleteHelpingDocument(`?helpingDocumentId=${id}`);
            toast.success(response.message);
            handleGetDocument();
        } catch (error) {
            console.error("Error Deleting Document.", error);
            toast.error("Error Deleting Document.");
        }
    }

    const handleCopyButton = async(url: string) => {

        const linkTag = `<a href="${url}">Click Here</a>`;
        if (!navigator.clipboard) {
            try {
                const textArea = document.createElement("textarea");
                textArea.value = linkTag;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
                toast.success("Button copied to clipboard!");
            } catch (err) {
                console.error("unable to copy", err);
                toast.error("Failed to copy Button.");
            }
            return;
        }
        try {
            await navigator.clipboard.writeText(linkTag);
            toast.success("Link copied to clipboard!");
        } catch (err) {
            console.error("Failed to copy: ", err);
            toast.error("Failed to copy link.");
        }
    }

    return (
        <Box className="manage-admin-container" padding='20px'>
            <Box className='manage-button d-flex justify-content-between'>
                <FormControl size="small" sx={{ width: "350px" }}>
                    <Autocomplete
                        disablePortal
                        id="mm-autocomplete"
                        options={documentType}

                        value={documentType.find((option) => option?.value === helpingDocumentTypeId) || null}
                        onChange={(event, newValue: any) => {
                            setHelpingDocumentTypeId(newValue?.value || null)
                        }}
                        getOptionLabel={(option: any) => option?.label || ""}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        renderInput={(params) => (
                            <TextField {...params} label="Select Document Type" />
                        )}

                    />
                </FormControl>
                <Typography variant="h3" sx={{ flexGrow: 1, textAlign: "center" }}>
                    Help Document
                </Typography>
                <Button variant="contained" className="table-row-background" onClick={() => { setOpen(true) }}>
                    Add Document
                </Button>
            </Box>
            <Table className="mt-2">
                <TableHead>
                    <TableRow className="table-row-background">
                        <TableCell sx={{ color: "#fff", width: "10%" }}>Seq No</TableCell>
                        <TableCell sx={{ color: "#fff", width: "20%", textAlign: 'center' }}>File Name</TableCell>
                        <TableCell sx={{ color: "#fff", width: "15%", textAlign: 'center' }}>File Link</TableCell>
                        <TableCell sx={{ color: "#fff", width: "15%", textAlign: 'center' }}>Date Uploaded</TableCell>
                        <TableCell sx={{ color: "#fff", width: "10%", textAlign: 'center' }}>Copy Button</TableCell>
                        <TableCell sx={{ color: "#fff", width: "10%", textAlign: 'center' }}>Client Group</TableCell>
                        <TableCell sx={{ color: "#fff", width: "10%", textAlign: 'center' }}>Copy Link</TableCell>
                        <TableCell sx={{ color: "#fff", width: "1%" }}></TableCell>
                        <TableCell sx={{ color: "#fff", width: "8%" }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {documentData.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={10} align="center" sx={{ py: 3, fontWeight: "bold", textAlign: "center", fontSize: "20px", color: 'lightred' }}>
                                No Help Document Data.
                            </TableCell>
                        </TableRow>
                    ) : (
                        documentData.map((data) => (
                            <TableRow key={''} sx={{ borderBottom: "1px solid #c0bfa2" }}>
                                <TableCell>{data?.orderNo}</TableCell>
                                <TableCell><Box sx={{ border: '2px solid gray', borderRadius: '5px', padding: 1 }}>{data?.name}</Box></TableCell>
                                <TableCell sx={{ textAlign: "center" }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className='table-row-background'
                                        onClick={() => { window.open(`${data.documentUrls}`) }}
                                    >
                                        Open File
                                    </Button>
                                </TableCell>
                                <TableCell sx={{ textAlign: "center" }}>{data.createdOn}</TableCell>
                                <TableCell sx={{ textAlign: "center" }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className='table-row-background'
                                        onClick={() => handleCopyButton(data.documentUrls)}
                                    >
                                        Copy Button
                                    </Button>
                                </TableCell >
                                <TableCell sx={{ textAlign: "center" }}><Box height={'28px'} component={'img'} src={data.clientGroupName === "ALDI" ? aldilogo : data.clientGroupName === "BLOOMS" ? bloomslogo : data.clientGroupName === "MM" ? mmlogo : data.clientGroupName === "TRANSPORT" ? mmlogo : ""}></Box></TableCell>
                                <TableCell sx={{ textAlign: "center" }}>
                                    <Button
                                        startIcon={<ContentCopyIcon />}
                                        onClick={() => handleCopyLink(data.documentUrls)}
                                    ></Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        onClick={() => {
                                            setEditingDocument(data);
                                            setFormData({
                                                seqNo: data?.orderNo || "",
                                                fileName: data?.name || "",
                                            });
                                            setUploadedFiles(data?.documentUrls ? [data.documentUrls] : []);
                                            setDialogDocumentTypeId(data?.helpingDocumentTypeId || null);
                                            setDialogClient(
                                                Clientlist.find((c) => c.clientGroupName === data.clientGroupName) || null
                                            );
                                            setDialogEntityId(data?.clientEntityId || null);
                                            setOpen(true);
                                        }}
                                    >
                                        <Box component="img" className="w-50" src={edit}></Box>
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        variant="contained"
                                        className="delete-transparent"
                                        onClick={() => {
                                            const isConfirmed = window.confirm(
                                                "Are you sure you want to delete the Site?"
                                            );
                                            if (isConfirmed) {
                                                handleDelete(data?.helpingDocumentId)
                                            }
                                        }}
                                    >
                                        <DeleteIcon className="delete-icon" />
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        width: "550px",
                        height: "fit-content",
                        maxWidth: "none",
                        borderRadius: "16px",
                    },
                }}
            >
                <DialogContent>
                    <Typography variant="h6" gutterBottom>
                        Add Document
                    </Typography>

                    <Box mt={2} display="flex" flexDirection="column" gap={2}>
                        <FormControl size="small">
                            <Autocomplete
                                disablePortal
                                id="dialog-doc-type"
                                options={documentType}
                                getOptionLabel={(option: any) => option?.label || ""}
                                value={documentType.find((option) => option?.value === dialogDocumentTypeId) || null}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                onChange={(event, newValue: any) => {
                                    setDialogDocumentTypeId(newValue?.value || null);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Document Type" />
                                )}
                            />
                        </FormControl>

                        <TextField
                            label="Seq No"
                            name="seqNo"
                            type="number"
                            value={formData.seqNo}
                            onChange={handleChange}
                            fullWidth
                            required
                        />
                        <TextField
                            label="File Name"
                            name="fileName"
                            value={formData.fileName}
                            onChange={handleChange}
                            fullWidth
                            required
                        />
                    </Box>

                    {/* Upload Section */}
                    <FormControl className='mt-3' fullWidth>
                        <Grid container className='w-100' spacing={2}>
                            {uploadedFiles.map((fileUrl, index) => (
                                <Grid size={12} key={index}>
                                    <Box
                                        className='w-100'
                                        sx={{
                                            position: 'relative',
                                            border: '2px dashed #ccc',
                                            borderRadius: '10px',
                                            overflow: 'hidden',
                                            height: '150px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexDirection: 'column',
                                            p: 2
                                        }}
                                    >
                                        {fileUrl.includes(".pdf") ? (
                                            <PictureAsPdfOutlined color="error" fontSize="large" />
                                        ) : (
                                            <InsertDriveFileOutlined color="action" fontSize="large" />
                                        )}

                                        <Typography
                                            variant="body2"
                                            noWrap
                                            sx={{
                                                maxWidth: '100%',
                                                mt: 1,
                                                textDecoration: 'underline',
                                                color: 'primary.main',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => window.open(fileUrl, '_blank')}
                                        >
                                            {fileUrl.split('/').pop()}
                                        </Typography>

                                        <IconButton
                                            onClick={() => handleRemoveFile(index)}
                                            sx={{
                                                position: 'absolute',
                                                top: 5,
                                                right: 5,
                                                bgcolor: 'white',
                                                '&:hover': { bgcolor: 'grey.100' },
                                            }}
                                        >
                                            <CancelOutlinedIcon color="error" />
                                        </IconButton>
                                    </Box>
                                </Grid>
                            ))}

                            {uploadedFiles.length === 0 && (
                                <Grid size={12}>
                                    <label htmlFor="help_document" className="w-100" style={{ fontSize: '14px', color: 'grey' }}>
                                        <Box
                                            className="d-flex flex-column align-items-center justify-content-center p-5 w-100"
                                            sx={{
                                                border: '2px dashed #ccc',
                                                borderRadius: '10px',
                                                position: 'relative',
                                                height: '150px'
                                            }}
                                        >
                                            <input
                                                type="file"
                                                style={{ opacity: 0, position: 'absolute' }}
                                                className="w-100 h-100"
                                                id="help_document"
                                                onChange={handleDocumentUpload}
                                            />
                                            <Upload />
                                            <div>Upload Here</div>
                                        </Box>
                                    </label>
                                </Grid>
                            )}
                        </Grid>
                    </FormControl>

                    <FormControl fullWidth size="small" className="mb-3 mt-3">
                        <Autocomplete
                            disablePortal
                            options={Clientlist}
                            value={dialogClient}
                            getOptionLabel={(option) => option?.clientGroupName || ""}
                            isOptionEqualToValue={(option, value) =>
                                option.clientGroupDBName === value.clientGroupDBName
                            }
                            onChange={(event, newValue: any) => {
                                setDialogClient(newValue);
                                setDialogEntityId(null);
                                setDialogEntityList([]);
                            }}

                            renderInput={(params) => (
                                <TextField {...params} label="Select Client(optional)" />
                            )}
                        />
                    </FormControl>

                    <FormControl fullWidth size="small" className="mb-1">
                        <Autocomplete
                            disablePortal
                            options={dialogEntityList.filter((item) => item.clientEntityId !== null)}
                            getOptionLabel={(option) => option?.entityName || ""}
                            value={
                                dialogEntityList.find((option) => option?.clientEntityId === dialogEntityId) || null
                            }
                            onChange={(event, newValue: any) =>
                                setDialogEntityId(newValue?.clientEntityId || null)
                            }
                            renderInput={(params) => (
                                <TextField {...params} label="Select Business(optional)" />
                            )}
                        />
                    </FormControl>

                    <DialogActions>
                        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
                            <Button
                                variant="contained"
                                onClick={handleClose}
                                className="table-row-background "
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                className="table-row-background "
                                onClick={handleSubmit}
                            >
                                {editingDocument ? "Update" : "Submit"}
                            </Button>
                        </Stack>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </Box>
    )
}
export default HelpDocument;